import React from 'react';

const block = {
  background: 'var(--br-hover-surface)',
  borderRadius: 'var(--br-control-radius)',
};

const SliderItemPlaceholder = () => (
  <div aria-hidden="true" style={{
    display: 'grid',
    gridTemplateColumns: 'minmax(75px, 100px) minmax(0, 1fr)',
    gap: 16,
    margin: '0 10px',
    maxWidth: 500,
  }}>
    <div style={{...block, width: '100%', aspectRatio: '2 / 3'}} />
    <div style={{display: 'grid', alignContent: 'center', gap: 10}}>
      {[0, 1, 2, 3, 4].map(index => (
        <div key={index} style={{...block, height: 12,
          width: index === 4 ? '60%' : '100%'}} />
      ))}
    </div>
  </div>
);

export default SliderItemPlaceholder;
